export const commonTextData = {
  homeMotivationShow: {
    ru: "Привет! MIX BRICKS – это фото-конструктор. Загрузи фото, и мы покажем, как будет выглядеть твой дизайн.",
    en: "Hello! MIX BRICKS is an endless photo-based construction kit. Upload a photo, and we’ll show you what your design will look like.",
    pl: "Cześć! MIX BRICKS to zestaw, który zamienia Twoje zdjęcie w wyjątkowy projekt z klocków. Prześlij zdjęcie i zobacz jak będzie wyglądał Twój projekt!",
    es: "¡Hola! MIX BRICKS es un set creativo ilimitado para la edición de fotos. Sube una imagen y te mostraremos cómo lucirá tu diseño.",
    it: "Trasforma le tue foto in ritratti originali di mattoncini con MIX BRICKS. Carica un’immagine e scopri subito il risultato.",
    de: "Hallo! MIX BRICKS ist ein kreativer Fotobausatz ohne Grenzen. Lade ein Bild hoch und wir zeigen dir, wie dein Design aussehen wird.",
    fr: "Bonjour! MIX BRICKS est un jeu de construction créatif basé sur tes photos. Télécharge une image et nous te montrerons à quoi ressemblera ton design.",
    cz: "Ahoj! MIX BRICKS je kreativní stavebnice z tvých fotografií. Nahraj fotku a ukážeme ti, jak bude vypadat tvůj výtvor.",
    hu: "Helló! A MIX BRICKS egy kreatív építőkészlet a saját fotóidból. Tölts fel egy képet, és megmutatjuk, hogyan fog kinézni az alkotásod.",
    gr: "Γεια! To MIX BRICKS είναι ένα ατελείωτο δημιουργικό σετ για τις φωτογραφίες σου. Ανέβασε μία και θα σου δείξουμε πώς θα μοιάζει το σχέδιό σου.",
    dk: "Hej! MIX BRICKS er en byggeoplevelse baseret på dine egne fotos – med uendelige muligheder. Upload et foto, og se straks hvordan dit design kommer til at se ud.",
    pt: "Olá! MIX BRICKS é um kit criativo infinito feito a partir das tuas fotos.Carrega uma imagem e mostramos-te como ficará a tua criação.",
  },
  homeMotivationBuy: {
    ru: "У тебя еще нет фото-конструктора? Тогда срочно приобретай!",
    en: "Don't have a photo-based construction kit yet? It's time to get one!",
    pl: "Nie masz jeszcze zestawu MIX BRICKS? Czas to zmienić!",
    es: "¿Aún no tienes un editor de fotos? Es hora de tener el tuyo!",
    it: "Non hai ancora un set MIX BRICKS? Provalo subito!",
    de: "Du hast noch keinen Fotobausatz? Dann wird's höchste Zeit, dir einen zu besorgen!",
    fr: "Tu n’as pas encore de kit MIX BRICKS ? C'est le moment d'en avoir un!",
    cz: "Ještě nemáš stavebnici MIX BRICKS? Tak je nejvyšší čas si ji pořídit!",
    hu: "Még nincs fotóalapú építőkészleted? Itt az ideje beszerezni egyet!",
    gr: "Δεν έχεις ακόμα το δημιουργικό σετ MIX BRICKS; Τότε είναι καιρός να το αποκτήσεις!",
    dk: "Har du endnu ikke et MIX BRICKS-sæt? Så er det på høje tid at få et!",
    pt: "Ainda não tens o teu conjunto MIX BRICKS?  Então, é altura de adquirir um!",
  },
  homeMotivationGetInstruction: {
    ru: "У тебя уже есть набор MIX BRICKS?",
    en: "Do you already have a MIX BRICKS kit?",
    pl: "Masz już zestaw MIX BRICKS?",
    es: "¿Ya tienes un set de MIX BRICKS?",
    it: "Hai già un set MIX BRICKS?",
    de: "Hast du schon ein MIX BRICKS-Set?",
    fr: "As-tu déjà un set MIX BRICKS?",
    cz: "Máš už sadu MIX BRICKS?",
    hu: "Már van MIX BRICKS készleted?",
    gr: "Έχεις ήδη ένα σετ MIX BRICKS;",
    dk: "Har du allerede et MIX BRICKS-sæt?",
    pt: "Já tens o teu conjunto MIX BRICKS?",
  },
  buttonCaptionShow: {
    ru: "Показать",
    en: "Show",
    pl: "Pokaż",
    es: "Mostrar",
    it: "Mostra",
    de: "Zeigen",
    fr: "Montrer",
    cz: "Zobrazit",
    hu: "Megjelenítés",
    gr: "Eμφάνιση",
    dk: "Vis",
    pt: "Mostrar",
  },
  buttonCaptionBuy: {
    ru: "Купить",
    en: "Buy",
    pl: "Kupić",
    es: "Comprar",
    it: "Acquista ora",
    de: "Kaufen",
    fr: "Acheter",
    cz: "Koupit",
    hu: "Vásárlás",
    gr: "Αγόρασέ το",
    dk: "Køb",
    pt: "Comprar",
  },
  buttonCaptionGetInstruction: {
    ru: "Получить Инструкцию",
    en: "Get Instructions",
    pl: "Pobierz Instrukcję",
    es: "Recibir La Guía",
    it: "Scarica la guida",
    de: "Anleitung anfordern",
    fr: "Recevoir la notice",
    cz: "Získat Návod",
    hu: "Utasítások",
    gr: "Λάβε τις οδηγίες",
    dk: "Få Instruktioner",
    pt: "Obter Instruções",
  },
  buttonCaptionLoad: {
    ru: "Загрузить",
    en: "Upload",
    pl: "Dodaj Plik",
    es: "Subir",
    it: "Carica foto",
    de: "Hochladen",
    fr: "Télécharger",
    cz: "Nahrát",
    hu: "Feltöltés",
    gr: "Μεταφόρτωση",
    dk: "Upload",
    pt: "Carregar",
  },
  buttonCaptionBack: {
    ru: "Назад",
    en: "Back",
    pl: "Wstecz",
    es: "Atrás",
    it: "Torna indietro",
    de: "Zurück",
    fr: "Retour",
    cz: "Zpět",
    hu: "Vissza",
    gr: "Πίσω",
    dk: "Tilbage",
    pt: "Voltar",
  },
  buttonCaptionNext: {
    ru: "Далее",
    en: "Next",
    pl: "Dalej",
    es: "Siguiente",
    it: "Continua",
    de: "Weiter",
    fr: "Suivant",
    cz: "Další",
    hu: "Következő",
    gr: "Επόμενο",
    dk: "Næste",
    pt: "Próximo",
  },
  buttonCaptionSend: {
    ru: "Отправить",
    en: "Send",
    pl: "Wyślij",
    es: "Enviar",
    it: "Invia",
    de: "Senden",
    fr: "Envoyer",
    cz: "Odeslat",
    hu: "Küldés",
    gr: "Αποστολή",
    dk: "Få vejledningen",
    pt: "Enviar",
  },
  buttonCaptionGoHome: {
    ru: "На Главную",
    en: "Home Page",
    pl: "Strona Główna",
    es: "Inicio",
    it: "Torna alla home",
    de: "Zur Startseite",
    fr: "Page d'accueil",
    cz: "Na Domovskou Stránku",
    hu: "Vissza a főoldalra",
    gr: "Αρχική σελίδα",
    dk: "Til Forsiden",
    pt: "Para a Página Inicial",
  },
  buttonCaptionStartAssembly: {
    ru: "Начать Сборку",
    en: "Start Assembly",
    pl: "Rozpocznij Montaż",
    es: "Comenzar el montaje",
    it: "Inizia montaggio",
    de: "Montage starten",
    fr: "Commencer l'assemblage",
    cz: "Začít Montáž",
    hu: "Összeszerelés elkezdése",
    gr: "Ξεκίνα τη συναρμολόγηση",
    dk: "Start samlingen",
    pt: "Iniciar Montagem",
  },
  buttonCaptionGetPDF: {
    ru: "PDF-инструкция",
    en: "PDF Instructions",
    pl: "Instrukcja PDF",
    es: "Guía En PDF",
    it: "Scarica guida (PDF)",
    de: "PDF-Anleitung",
    fr: "Instruction PDF",
    cz: "PDF Návod",
    hu: "PDF-útmutató",
    gr: "Οδηγίες σε PDF",
    dk: "PDF-vejledning",
    pt: "Instruções Em PDF",
  },
  buttonCaptionClear: {
    ru: "Oчистить",
    en: "Clear",
    pl: "Wyczyść",
    es: "Borrar",
    it: "Annulla",
    de: "Zurücksetzen",
    fr: "Réinitialiser",
    cz: "Resetovat",
    hu: "Törlés",
    gr: "Επαναφορά",
    dk: "Ryd",
    pt: "Limpar",
  },
  motivationLoadImage: {
    ru: "Загрузи любуsю фотографию из своей медиатеки.",
    en: "Upload any photo from your media library.",
    pl: "Prześlij dowolne zdjęcie ze swojej galerii.",
    es: "Sube cualquier foto desde tu biblioteca multimedia.",
    it: "Seleziona una foto dalla tua galleria.",
    de: "Wähle ein Foto aus deiner Mediathek und lade es hoch.",
    fr: "Télécharge une photo depuis ta galerie.",
    cz: "Nahraj libovolnou fotografii ze své mediální knihovny.",
    hu: "Tölts fel bármilyen fotót a médiatáradból.",
    gr: "Ανέβασε οποιαδήποτε φωτογραφία από τη βιβλιοθήκη πολυμέσων σου.",
    dk: "Upload et hvilket som helst foto fra dit mediebibliotek.",
    pt: "Carrega qualquer foto da tua galeria.",
  },
  noteSizeLimit: {
    ru: "размер файла должен быть не больше 15 Мб",
    en: "Maximum file size: 15 MB",
    pl: "Maksymalny rozmiar pliku: 15 MB",
    es: "Tamaño máximo del archivo: 15 MB",
    it: "Dimensione massima del file: 15 MB",
    de: "Maximale Dateigröße: 15 MB",
    fr: "Taille maximale du fichier: 15 Mo",
    cz: "Maximální velikost souboru: 15 MB",
    hu: "Maximális fájlméret: 15 MB",
    gr: "Μέγιστο μέγεθος αρχείου: 15 MB",
    dk: "Maksimal filstørrelse: 15 MB",
    pt: "Tamanho máximo do ficheiro: 15 MB",
  },
  motivationSelectImageZone: {
    ru: "Выдели желаемую зону на своём снимке.",
    en: "Select the area you want to use from your photo.",
    pl: "Wybierz fragment zdjęcia, który chcesz wykorzystać.",
    es: "Selecciona el área de tu foto que deseas usar.",
    it: "Seleziona l'area della foto da includere.",
    de: "Wähle den gewünschten Bereich auf deinem Foto aus.",
    fr: "Sélectionne la zone souhaitée sur ta photo.",
    cz: "Vyber požadovanou oblast na fotografii.",
    hu: "Emeld ki a kívánt területet a fotódon.",
    gr: "Επισήμανε την περιοχή στη φωτογραφία που θέλεις να χρησιμοποιήσεις.",
    dk: "Vælg det område, du vil fremhæve på dit foto.",
    pt: "Seleciona a área da foto que pretendes usar.",
  },
  artPreviewSuppose: {
    ru: "Так будет выглядеть твой будущий конструктор",
    en: "This is what your future constructor will look like",
    pl: "Tak będzie wyglądał Twój przyszły obraz",
    es: "Así se verá tu futuro editor",
    it: "Ecco come sarà il tuo futuro mosaico",
    de: "So wird dein fertiger Fotobausatz aussehen",
    fr: "Voici à quoi ressemblera ton futur constructeur",
    cz: "Takto bude vypadat tvá budoucí stavebnice",
    hu: "Így fog kinézni a készleted",
    gr: "Έτσι θα φαίνεται το μελλοντικό σου κιτ",
    dk: "Sådan kommer din mosaik til at se ud",
    pt: "É assim que vai ficar o teu futuro kit",
  },
  verifyCodeTitle: {
    ru: "Введи восьмизначный код из инструкции к набору. Если у тебя их несколько, то введи код одного из наборов.",
    en: "Enter the 8-digit code from the kit instructions. If you have several, enter the code from one of the kits.",
    pl: "Wprowadź ośmiocyfrowy kod z instrukcji w zestawie. Jeśli masz kilka zestawów, wystarczy kod z jednego z nich.",
    es: "Introduce el código de 8 dígitos que se encuentra en las instrucciones del set. Si tienes varios kits, introduce el código uno de ellos.",
    it: "Inserisci il codice a 8 cifre delle istruzioni. Se hai più set, scegline uno.",
    de: "Gib den achtstelligen Code aus der Bauanleitung ein. Wenn du mehrere hast, gib den Code eines der Sets ein.",
    fr: "Entre le code à huit chiffres de la notice du kit. Si tu en as plusieurs, entre celui de l’un des kits.",
    cz: "Zadej osmimístný kód z návodu k sadě. Pokud jich máš několik, zadej kód jedné ze sad.",
    hu: "Írd be a nyolcjegyű kódot a készlet útmutatójából. Ha több van, írd be az egyik készlet kódját.",
    gr: "Εισαγάγετε τον 8ψήφιο κωδικό από τις οδηγίες του σετ. Αν έχετε περισσότερους, εισαγάγετε τον κωδικό ενός από τα σετ.",
    dk: "Indtast den ottecifrede kode fra sættets vejledning. Hvis du har flere, så indtast koden fra et af sættene.",
    pt: "Insere o código de 8 dígitos do manual do teu kit. Se tiveres vários, insere o código de um deles.",
  },
  motivationEmailInput: {
    ru: "Ты почти у цели! Осталось ввести адрес почты и мы сразу отправим на нее инструкцию для сборки",
    en: "You're almost there! Just enter your email and we'll immediately send you the assembly instructions",
    pl: "Jesteś prawie u celu! Wprowadź swój adres e-mail, a my natychmiast wyślemy instrukcje montażu",
    es: "¡Ya casi llegas! Introduce tu correo electrónico y te enviaremos las instrucciones de montaje",
    it: "Ci sei quasi! Inserisci la tua e-mail per ricevere subito le istruzioni",
    de: "Du bist fast am Ziel! Gib deine E-Mail ein, und wir senden dir sofort die Anleitung",
    fr: "Tu y es presque ! Entre ton adresse e-mail et nous t’enverrons tout de suite la notice de montage",
    cz: "Jsi téměř u cíle! Stačí zadat svůj e-mail a hned ti pošleme návod",
    hu: "Már majdnem kész vagy! Add meg az e-mailed, és azonnal küldjük az útmutatót",
    gr: "Σχεδόν τελειώσαμε! Εισάγαγε το email σου και θα σου στείλουμε αμέσως τις οδηγίες συναρμολόγησης",
    dk: "Du er næsten færdig! Indtast din e-mailadresse, så sender vi straks samlevejledningen til dig.",
    pt: "Estás quase lá! Introduz o teu e-mail e enviamos-te já as instruções",
  },
  emailAdditionalText: {
    ru:
      'Нажимая на кнопку "Отправить", я даю разрешение ООО "ГЕВИС" в целях информирования меня о специальных предложениях и ценах обрабатывать: собирать, записывать, систематизировать, накапливать, хранить, уточнять (обновлять, изменять), извлекать, использовать,\n' +
      'передавать (в том числе поручать обработку другим лицам), обезличивать, блокировать, удалять, уничтожать мои персональные данные: адрес электронной почты. Согласие может быть отозвано мною в любой момент путем направления письменного уведомления по адресу ООО "ГЕВИС". Ознакомиться с политикой персональных данных.',
    en:
      'By clicking "Send", I consent to the processing, collection, recording, systematization, accumulation, storage, updating, modification, extraction, use,\n' +
      "transfer (including entrusting processing to third parties), anonymization, blocking, deletion, and destruction of my personal data (email address) for the purpose of receiving information about special offers and prices. I can withdraw this consent at any time by sending a written notice to support@mixbricks.store.",
    pl:
      "Klikając „Wyślij”, wyrażam zgodę na przetwarzanie, gromadzenie, rejestrowanie, systematyzowanie, przechowywanie, aktualizowanie, modyfikowanie, pobieranie, wykorzystywanie,\n" +
      "przekazywanie (w tym zlecanie przetwarzania osobom trzecim), anonimizowanie, blokowanie, usuwanie i niszczenie moich danych osobowych (adresu e-mail) w celu otrzymywania informacji o ofertach specjalnych i cenach. Zgodę można wycofać w dowolnym momencie, wysyłając pisemne powiadomienie na adres support@mixbricks.store.",
    es:
      'Al hacer clic en el botón "Enviar", doy mi consentimiento para el procesamiento, recopilación, registro, sistematización, almacenamiento, actualización, modificación, extracción, uso,\n' +
      "transferencia (incluida la delegación del tratamiento a terceros), anonimización, bloqueo, eliminación y destrucción de mis datos personales (dirección de correo electrónico) con el fin de recibir información sobre ofertas y precios especiales. Este consentimiento puede ser revocado en cualquier momento enviando una notificación por escrito a support@mixbricks.store.",
    it:
      `Facendo clic sul pulsante Invia, acconsento al trattamento, alla raccolta, alla registrazione, alla sistematizzazione, all’accumulo, alla conservazione,\n` +
      "all’aggiornamento (modifica), all’estrazione, all’utilizzo, al trasferimento (anche a terzi), all’anonimizzazione, al blocco, alla cancellazione e alla distruzione dei miei dati personali (indirizzo e-mail), allo scopo di ricevere informazioni su offerte e prezzi speciali. Il consenso può essere revocato in qualsiasi momento inviando una comunicazione scritta a support@mixbricks.store.",
    de:
      "Durch Klicken auf die Schaltfläche „Senden“ erkläre ich mich damit einverstanden, dass meine personenbezogenen Daten (E-Mail-Adresse) zum Zweck der Information über Sonderangebote und Preise verarbeitet und gespeichert werden. Dies schließt die Aktualisierung, den Abruf, die Nutzung,\n" +
      "die Übertragung (auch an Dritte), die Anonymisierung, die Sperrung, die Löschung und die Vernichtung meiner Daten ein. Diese Einwilligung kann von mir jederzeit durch schriftliche Mitteilung an support@mixbricks.store widerrufen werden.",
    fr:
      `En cliquant sur le bouton "Envoyer", je donne mon consentement pour le traitement, la collecte, l'enregistrement, la systématisation, l'accumulation, le stockage, la mise à jour (modification), l'extraction, l'utilisation,\n` +
      `le transfert (y compris la sous-traitance à des tiers), l'anonymisation, le blocage, la suppression et la destruction de mes données personnelles (adresse e-mail) dans le but de m'informer sur les offres et les prix spéciaux. Ce consentement peut être révoqué à tout moment en envoyant une notification écrite à support@mixbricks.store.`,
    cz:
      "Kliknutím na tlačítko „Odeslat“ dávám svůj souhlas se zpracováním, shromažďováním, zaznamenáváním, systematizací, akumulací, ukládáním, upřesňováním (aktualizací, změnou), získáváním, používáním,\n" +
      "předáváním (včetně pověření zpracováním jiným osobám), anonymizací, blokováním, mazáním a ničením mých osobních údajů (e-mailové adresy) za účelem informování o speciálních nabídkách a cenách. Souhlas mohu kdykoli odvolat písemným oznámením na adresu support@mixbricks.store.",
    hu:
      "Az „Elküldés” gombra kattintva hozzájárulok ahhoz, hogy személyes adataimat (e-mail-címemet) a különleges ajánlatokról és árakról való tájékoztatás céljából kezeljék, gyűjtsék, rögzítsék, rendszerezzék, tárolják,\n" +
      "pontosítsák (frissítsék, módosítsák), kinyerjék, felhasználják, továbbítsák (beleértve harmadik felek feldolgozását), anonimizálják, blokkolják, töröljék és megsemmisítsék. A hozzájárulásomat bármikor visszavonhatom írásos értesítéssel a support@mixbricks.store címre.",
    gr:
      'Πατώντας το κουμπί «Αποστολή», δίνω τη συγκατάθεσή μου για την επεξεργασία, συλλογή, καταγραφή, συστηματοποίηση, σώρευση,\n' +
      "αποθήκευση, επικαιροποίηση, τροποποίηση, εξαγωγή, χρήση, μεταφορά (συμπεριλαμβανομένης της ανάθεσης της επεξεργασίας σε τρίτους), ανωνυμοποίηση, φραγή, διαγραφή και καταστροφή των προσωπικών μου δεδομένων (διεύθυνση ηλεκτρονικού ταχυδρομείου) με σκοπό την ενημέρωσή μου για ειδικές προσφορές και τιμές. Αυτή η συγκατάθεση μπορεί να ανακληθεί ανά πάσα στιγμή κατόπιν γραπτής ειδοποίησής μου στη διεύθυνση support@mixbricks.store.",
    dk:
      'Ved at klikke på "Send" giver jeg mit samtykke til behandling, indsamling, registrering, systematisering, akkumulering, opbevaring, præcisering (opdatering, ændring), udtrækning, brug,\n' +
      "overførsel (herunder overladelse af behandling til andre), anonymisering, blokering, sletning og destruktion af mine personoplysninger (e-mailadresse) med det formål at informere mig om særlige tilbud og priser. Samtykket kan til enhver tid tilbagekaldes ved skriftlig meddelelse til support@mixbricks.store.",
    pt:
      'Ao clicar em "Enviar", dou o meu consentimento para o tratamento, recolha, registo, sistematização, acumulação, armazenamento, clarificação (atualização, alteração), extração, utilização,\n' +
      "transferência (incluindo a subcontratação a terceiros), anonimização, limitação, eliminação e destruição dos meus dados pessoais (endereço de e-mail) com o objetivo de me informar sobre ofertas e preços especiais. Este consentimento pode ser revogado a qualquer momento através de notificação escrita para support@mixbricks.store.",
  },
  emailPlaceholder: {
    ru: "Твой e-mail",
    en: "Your email",
    pl: "Twój e-mail",
    es: "Tu correo electrónico",
    it: "Inserisci la tua e-mail",
    de: "Deine E-Mail",
    fr: "Ton adresse e-mail",
    cz: "Tvůj e-mail",
    hu: "Az e-mailed",
    gr: "Το email σου",
    dk: "Din e-mail",
    pt: "O teu e-mail",
  },
  emailInstruction: {
    ru: "Ваша инструкция для печати и для мобильной сборки у вас на почте. Так же можете приступить к сборке с мобильных устройств прямо сейчас.",
    en: "Your instructions for printing and online assembly are already in your inbox. You can start assembly right away on your mobile device too.",
    pl: "Twoja instrukcja do druku i montażu online jest już w Twojej skrzynce. Możesz też zacząć budowę na telefonie już teraz.",
    es: "Las instrucciones para imprimir y para el montaje fotográfico en línea están en tu bandeja de entrada. También puedes empezar el montaje desde tu dispositivo móvil ahora mismo.",
    it: "La guida è ora nelle tue mani: inizia subito a costruire il tuo ritratto di mattoncini anche dal cellulare.",
    de: "Deine Druck- und Online-Bauanleitungen findest du in deiner E-Mail. Oder starte direkt mit dem Smartphone.",
    fr: "Ton guide pour l’impression et l’assemblage en ligne est dans ta boîte mail. Tu peux aussi commencer depuis ton appareil mobile dès maintenant.",
    cz: "Tvoje pokyny pro tisk a online montáž jsou ve tvém e-mailu. Můžeš také začít přímo ze svého mobilního zařízení.",
    hu: "A nyomtatáshoz és online összeszereléshez szükséges útmutató már ott van az e-mailedben. Akár azonnal el is kezdheted az összerakást a mobilkészülékeden.",
    gr: "Οι οδηγίες για εκτύπωση και online συναρμολόγηση βρίσκονται ήδη στο email σου. Μπορείς να ξεκινήσεις και από το κινητό σου αμέσως.",
    dk: "Dine instruktioner til print og online samling er sendt til din e-mail. Du kan også starte samlingen direkte på din mobile enhed nu.",
    pt: "As instruções para impressão e montagem online já foram enviadas para o teu e-mail. Também podes começar a montar agora mesmo no teu dispositivo móvel",
  },
  emailConfirmation: {
    ru: "Это правильная почта?",
    en: "Make sure your email address is correct",
    pl: "Czy Twój adres e-mail jest poprawny?",
    es: "Verifica que tu correo electrónico sea correcto",
    it: "Assicurati che l’indirizzo inserito sia corretto",
    de: "Überprüfe, ob deine E-Mail-Adresse korrekt ist",
    fr: "Vérifie que ton adresse e-mail est correcte",
    cz: "Zkontroluj, zda je e-mailová adresa správná",
    hu: "Ellenőrizd, hogy helyesen adtad-e meg az e-mail-címet",
    gr: "Έλεγξε αν έχεις εισαγάγει σωστά το email σου",
    dk: "Tjek, at din e-mailadresse er korrekt indtastet",
    pt: "Verifica se introduziste corretamente o teu e-mail",
  },
  emailInstructionConfirm: {
    ru: "Твоя инструкция будет отправлена на почту",
    en: "The instructions will be sent to your email",
    pl: "Instrukcja zostanie wysłana na Twój adres e-mail",
    es: "Las instrucciones serán enviadas a tu bandeja de entrada",
    it: "Ti invieremo la guida via e-mail a questo indirizzo",
    de: "Die Bauanleitung erhältst du per E-Mail",
    fr: "La notice te sera envoyée par e-mail",
    cz: "Návod ti bude odeslán e-mailem",
    hu: "Az útmutatót elküldjük az e-mail-címedre",
    gr: "Οι οδηγίες θα σταλούν στο email σου",
    dk: "Vejledningen bliver sendt til din e-mail",
    pt: "As instruções serão enviadas para o teu e-mail",
  },
  motivationQuantitySelect: {
    ru: "Выберите количество своих наборов",
    en: "Choose the number of your sets",
    pl: "Wybierz liczbę swoich zestawów",
    es: "Elige la cantidad de tus kits",
    it: "Scegli il numero dei tuoi set",
    de: "Wähle die Anzahl deiner Sets",
    fr: "Choisis le nombre de tes kits",
    cz: "Vyber počet svých sad",
    hu: "Válaszd ki a készleteid számát",
    gr: "Επίλεξε τον αριθμό των σετ σου",
    dk: "Vælg antallet af dine sæt",
    pt: "Escolhe o número dos teus kits",
  },
  quantityOption1: {
    ru: "1 Набор MIX BRICKS",
    en: "1 MIX BRICKS Set",
    pl: "1 zestaw MIX BRICKS",
    es: "1 kit MIX BRICKS",
    it: "1 set MIX BRICKS",
    de: "1 MIX BRICKS-Set",
    fr: "1 kit MIX BRICKS",
    cz: "1 sada MIX BRICKS",
    hu: "1 MIX BRICKS készlet",
    gr: "1 σετ MIX BRICKS",
    dk: "1 MIX BRICKS-sæt",
    pt: "1 kit MIX BRICKS",
  },
  quantityOption2: {
    ru: "2 набора MIX BRICKS",
    en: "2 MIX BRICKS Sets",
    pl: "2 zestawy MIX BRICKS",
    es: "2 kits MIX BRICKS",
    it: "2 set MIX BRICKS",
    de: "2 MIX BRICKS-Sets",
    fr: "2 kits MIX BRICKS",
    cz: "2 sady MIX BRICKS",
    hu: "2 MIX BRICKS készlet",
    gr: "2 σετ MIX BRICKS",
    dk: "2 MIX BRICKS-sæt",
    pt: "2 kits MIX BRICKS",
  },
  quantityOption3: {
    ru: "4 набора MIX BRICKS",
    en: "4 MIX BRICKS Sets",
    pl: "4 zestawy MIX BRICKS",
    es: "4 kits MIX BRICKS",
    it: "4 set MIX BRICKS",
    de: "4 MIX BRICKS-Sets",
    fr: "4 kits MIX BRICKS",
    cz: "4 sady MIX BRICKS",
    hu: "4 MIX BRICKS készlet",
    gr: "4 σετ MIX BRICKS",
    dk: "4 MIX BRICKS-sæt",
    pt: "4 kits MIX BRICKS",
  },
  buttonCaptionItsClear: {
    ru: "понятно",
    en: "Got it",
    pl: "Rozumiem",
    es: "Entendido",
    it: "OK",
    de: "Verstanden",
    fr: "Compris",
    cz: "Rozumím",
    hu: "Értem",
    gr: "Εντάξει",
    dk: "Forstået",
    pt: "Entendi",
  },
  buttonCaptionYes: {
    ru: "да",
    en: "Yes",
    pl: "Tak",
    es: "Sí",
    it: "Conferma",
    de: "Ja",
    fr: "Oui",
    cz: "Ano",
    hu: "Igen",
    gr: "Ναι",
    dk: "Bekræft",
    pt: "Sim",
  },
  buttonCaptionNo: {
    ru: "нет",
    en: "No",
    pl: "Nie",
    es: "No",
    it: "Modifica",
    de: "Nein",
    fr: "Non",
    cz: "Ne",
    hu: "Nem",
    gr: "Όχι",
    dk: "Tilbage",
    pt: "Não",
  },
  explainSelectionRule: {
    ru: "Постарайся выделить крупные объекты, например, лица.",
    en: "Try to select large objects, like faces.",
    pl: "Staraj się wybierać zdjęcia z dużymi obiektami – zobacz przykład poniżej.",
    es: "Intenta seleccionar objetos grandes, como rostros.",
    it: "Scegi immagini con soggetti in primo piano per risultati ottimali.",
    de: "Wähle möglichst große Objekte aus – zum Beispiel Gesichter.",
    fr: "Essaie de sélectionner de grands objets, comme des visages.",
    cz: "Zaměřuj se na větší objekty, například obličeje.",
    hu: "Törekedj arra, hogy nagyobb objektumokat válassz, például arcokat.",
    gr: "Προσπάθησε να επιλέξεις μεγάλα αντικείμενα, όπως πρόσωπα.",
    dk: "Prøv at vælge tydelige objekter, for eksempel ansigter.",
    pt: "Tenta selecionar objetos grandes, como rostos",
  },
  explainBackgroundRule: {
    ru: "Главное правила хорошей мозаики - избегать однотонного фона",
    en: "The main rule of a good mosaic is to avoid a monochrome background.",
    pl: "Główna zasada dobrej mozaiki – unikać jednolitego tł.",
    es: "La regla principal de un buen mosaico es evitar fondos uniformes.",
    it: "La regola principale di un buon mosaico è evitare uno sfondo uniforme.",
    de: "Die wichtigste Regel für ein gutes Mosaik: Vermeide einen einfarbigen Hintergrund.",
    fr: "La règle principale d’une bonne mosaïque : éviter un fond uni.",
    cz: "Hlavní pravidlo dobré mozaiky – vyhněte se jednobarevnému pozadí.",
    hu: "A jó mozaik legfontosabb szabálya: kerüld az egyszínű hátteret.",
    gr: "Ο βασικός κανόνας για καλή ψηφιδοποίηση είναι να αποφεύγεις τα μονόχρωμα φόντα.",
    dk: "Den vigtigste regel for en god mosaik er at undgå ensfarvede baggrunde.",
    pt: "A regra principal para um bom mosaico é evitar um fundo uniforme.",
  },
  uniqueCodePlaceholder: {
    ru: "Уникальный код",
    en: "Unique code",
    pl: "Unikalny kod",
    es: "Código único",
    it: "Codice set",
    de: "Individueller Code",
    fr: "Code unique",
    cz: "Unikátní kód",
    hu: "Egyedi kód",
    gr: "Μοναδικός κωδικός",
    dk: "Unik kode",
    pt: "Código único",
  },
  assemblyFooterText: {
    ru: '* Для удобства сборки, нажмите два раза на ячейку, на которой остановились. Так Вы отметите уже собранные кубики. Если Вы выбрали неправильную ячейку, то воспользуйтесь кнопкой "НАЗАД". Для совместной сборки можете открыть ссылку на других телефонах. При закрытии страницы все отметки сохраняются. Обязательно собирайте мозаику по порядку — начиная сверху и двигаясь линия за линией.',
    en: `* For your convenience, double-click the cell where you stopped. This way you'll mark the cubes you've already placed. If you chose the wrong one, use the "BACK" button. For collaborative assembly, you can open the link on other devices. All marks are saved when the page is closed. Make sure to build the mosaic in order — starting from the top and moving line by line.`,
    pl: "* Dla wygody montażu kliknij dwukrotnie komórkę, na której się zatrzymałeś. Zaznaczysz w ten sposób już ułożone kostki. Jeśli zaznaczysz złą, użyj przycisku „WSTECZ”. Dla wspólnego składania możesz udostępnić link na innych urządzeniach. Przy zamknięciu strony wszystkie zaznaczenia zostaną zapisane. Upewnij się, że układasz mozaikę krok po kroku — zaczynając od góry i przesuwając się linia po linii.",
    es: '* Para facilitar el montaje, haz doble clic en la celda donde se ubica el cursor para marcar las celdas. Si la selección no es la correcta, utiliza el botón "ATRÁS". Para realizar un montaje colaborativo, abre el enlace en otros dispositivos. Todas las celdas marcadas se guardarán al cerrar la página. Asegúrate de montar el mosaico paso a paso, empezando desde la parte superior y continuando línea por línea.',
    it: `* Per semplificare il processo di costruzione, fai doppio clic sulla casella in cui hai interrotto il lavoro: così vedrai quali mattoncini hai già posizionato. Se selezioni quella sbagliata, usa il pulsante "Torna indietro". Vuoi costruire insieme ad altre persone? Condividi il link: chi lo apre da altri dispositivi vedrà e salverà i progressi in tempo reale. Per ottenere un risultato ordinato, posiziona i mattoncini dall’alto verso il basso, riga dopo riga.`,
    de: "* Für die Montage doppelklicke auf das Feld, bei dem du aufgehört hast – so markierst du bereits platzierte Würfel. Hast du das falsche Feld gewählt, nutze den Button „ZURÜCK“. Zum gemeinsamen Bauen öffne den Link auf anderen Geräten. Alle Markierungen bleiben beim Schließen der Seite erhalten. Baue das Mosaik unbedingt in der richtigen Reihenfolge: oben beginnen und Zeile für Zeile nach unten arbeiten.",
    fr: "* Pour faciliter l’assemblage, double-cliquez sur la cellule où vous vous êtes arrêté. Cela marquera les cubes déjà placés. En cas d’erreur, utilisez le bouton « RETOUR ». Pour un montage collaboratif, ouvrez le lien sur d'autres appareils. Toutes les marques sont sauvegardées à la fermeture. Assurez-vous d’assembler la mosaïque dans l’ordre — en commençant par le haut et en suivant ligne par ligne.",
    cz: "* Pro snadnější sestavení dvakrát klikni na políčko, kde ses zastavil. Označíš tak už složené kostky. Pokud jsi klikl omylem, použij tlačítko „ZPĚT“. Pro společné skládání otevři odkaz na jiných zařízeních. Po zavření stránky zůstanou všechna označení uložena. Ujistěte se, že skládáte mozaiku postupně — začněte nahoře a pokračujte řádek po řádku.",
    hu: "* A könnyebb összeállítás érdekében kattints duplán arra a cellára, ahol abbahagytad. Így megjelölöd azokat a kockákat, amiket már elhelyeztél. Ha rosszat választottál, használd a „VISSZA” gombot. Többeszközös építéshez nyisd meg a linket más telefonokon. Az összes jelölés mentésre kerül az oldal bezárásakor. Ügyelj arra, hogy a mozaikot sorrendben rakd össze — fentről lefelé, soronként haladva.",
    gr: '* Για ευκολότερη συναρμολόγηση, κάνε διπλό κλικ στο κελί όπου σταμάτησες — έτσι θα σημειώσεις τους κύβους που έχεις ήδη τοποθετήσει. Αν έκανες λάθος επιλογή, πάτησε το κουμπί «ΠΙΣΩ». Για κοινή συναρμολόγηση, μπορείς να ανοίξεις τον σύνδεσμο σε άλλα τηλέφωνα/συσκευές. Όλες οι σημάνσεις σου αποθηκεύονται κατά το κλείσιμο της σελίδας. Βεβαιώσου ότι συναρμολογείς το ψηφιδωτό με τη σωστή σειρά, ξεκινώντας από πάνω και προχωρώντας γραμμή προς γραμμή.',
    dk: '* For at gøre samlingen lettere, dobbeltklik på cellen, hvor du stoppede. Så markerer du de klodser, der allerede er placeret. Hvis du klikkede forkert, brug knappen "TILBAGE". Til fællessamling kan du åbne linket på andre enheder. Alle markeringer gemmes, når siden lukkes. Sørg for at samle mosaikken i den rigtige rækkefølge — start øverst og gå frem linje for linje.',
    pt: "* Para facilitar a montagem, clica duas vezes na célula onde paraste. Assim, vais marcar os cubos já colocados. Se escolheres a célula errada, usa o botão “VOLTAR”. Para montagem colaborativa, abre o link noutros dispositivos. Todas as marcações são guardadas ao fechares a página. Certifica-te de montar o mosaico na ordem certa — começando pelo topo e seguindo linha a linha.",
  },
  assemblyPDFLink: {
    ru: "Открыть PDF-инструкцию",
    en: "Open PDF instructions",
    pl: "Otwórz instrukcję PDF",
    es: "Abrir las instrucciones en PDF",
    it: "Visualizza PDF istruzioni",
    de: "Öffne die PDF-Anleitung",
    fr: "Ouvrir les instructions PDF",
    cz: "Otevřít PDF návod",
    hu: "Nyisd meg a PDF-utasítást",
    gr: "Άνοιξε τις οδηγίες PDF",
    dk: "Åbn PDF-vejledningen",
    pt: "Abrir instruções em PDF",
  },
  mobileTutorialBlock1: {
    ru: "Основа 32х32 из набора",
    en: "32x32 base from the kit",
    pl: "Podstawa 32x32 z zestawu",
    es: "Base 32x32 del kit",
    it: "Base 32x32 del set",
    de: "32x32-Basis aus dem Set",
    fr: "Base 32x32 du kit",
    cz: "Základna 32x32 ze sady",
    hu: "32x32-es alap a készletből",
    gr: "Βάση 32x32 από το σετ",
    dk: "32x32 base fra sættet",
    pt: "Base 32x32 do kit",
  },
  mobileTutorialBlock2: {
    ru: "Увеличить изображение, чтобы увидеть основу и область сборки",
    en: "Zoom in to view the base and the assembly area",
    pl: "Powiększ obraz, aby zobaczyć podstawę i obszar składania",
    es: "Amplía la imagen para ver la base y la zona de montaje",
    it: "Ingrandisci l’immagine per vedere la base e l’area di montaggio",
    de: "Bild vergrößern, um die Basis und den Montagebereich zu sehen",
    fr: "Agrandis l’image pour voir la base et la zone d’assemblage",
    cz: "Přibliž si obrázek, abys viděl základnu a oblast sestavení",
    hu: "Nagyítsd ki a képet, hogy lásd az alapot és az összeszerelési területet",
    gr: "Μεγέθυνε για να δεις τη βάση και την περιοχή συναρμολόγησης",
    dk: "Zoom ind for at se basen og samlingsområdet",
    pt: "Amplia a imagem para veres a base e a área de montagem",
  },
  mobileTutorialBlock3: {
    ru: "Одно нажатие – выбор пикселя для заполнения, двойное нажатие – заполнение пикселя и сохранение шага",
    en: "Single click – select pixel to fill, double click – fill pixel and save step",
    pl: "Jedno kliknięcie – wybór piksela do wypełnienia, podwójne – wypełnienie i zapisanie kroku",
    es: "Un clic: selecciona el pixel para rellenar. Doble clic: rellena y guarda la selección",
    it: "Un clic: seleziona la casella dove posizionare il mattoncino. Doppio clic: inserisci il mattoncino e salva la tua scelta.",
    de: "Ein Klick: Pixel auswählen. Doppelklick: Pixel ausfüllen und Schritt speichern.",
    fr: "Un clic: sélectionner un pixel à remplir. Double clic : le remplir et enregistrer l’étape.",
    cz: "Jedno kliknutí – výběr pixelu, dvojité – vyplnění a uložení kroku",
    hu: "Egy kattintás – pixel kijelölése, dupla katt – kitöltés és lépés mentése",
    gr: "Ένα κλικ: επιλογή εικονοστοιχείου διπλό κλικ: συμπλήρωση και αποθήκευση",
    dk: "Ét klik – vælg pixel, dobbeltklik – udfyld og gem trin",
    pt: "Um clique – selecionar pixel, dois cliques – preencher e salvar passo",
  },
  mobileTutorialBlock4: {
    ru: "Область на выбранной основе 32х32 из набора",
    en: "Selected area on the 32x32 base from the kit",
    pl: "Wybrany obszar na podstawie 32x32 z zestawu",
    es: "Área seleccionada en la base 32x32 del kit",
    it: "Area selezionata sulla base 32x32 del set",
    de: "Bereich auf der ausgewählten 32x32-Basis aus dem Set",
    fr: "Zone sur la base 32x32 sélectionnée du kit",
    cz: "Oblast na vybrané základně 32x32 ze sady",
    hu: "Terület a kiválasztott 32x32-es alapon a készletből",
    gr: "Περιοχή στη βάση 32x32 που επιλέχθηκε από το σετ",
    dk: "Område på den valgte 32x32-base fra sættet",
    pt: "Área na base 32x32 selecionada do kit",
  },
  assemblyBaseTitle: {
    ru: "Выбери основу",
    en: "Choose a base",
    pl: "Wybierz podstawę",
    es: "Elige una base",
    it: "Scegli una base",
    de: "Wähle eine Basis",
    fr: "Choisis une base",
    cz: "Vyber základnu",
    hu: "Válassz alapot",
    gr: "Επίλεξε βάση",
    dk: "Vælg en base",
    pt: "Escolhe uma base",
  },
  assemblyViewHelpButton: {
    ru: "Как это работает?",
    en: "How does it work?",
    pl: "Jak to działa?",
    es: "¿Cómo funciona?",
    it: "Come funziona?",
    de: "Wie funktioniert das?",
    fr: "Comment ça marche ?",
    cz: "Jak to funguje?",
    hu: "Hogyan működik?",
    gr: "Πώς λειτουργεί αυτό;",
    dk: "Hvordan virker det?",
    pt: "Como funciona?",
  },
  assemblyAreaTitle: {
    ru: "Выбери область сборки на основе",
    en: "Choose the assembly area on the base",
    pl: "Wybierz obszar do zbudowania na podstawie",
    es: "Elige el área de montaje en la base",
    it: "Scegli l’area di costruzione sulla base",
    de: "Wähle den Bereich auf der Basis, den du zusammensetzen willst",
    fr: "Choisis la zone d’assemblage sur la base",
    cz: "Vyber oblast sestavení na základně",
    hu: "Válaszd ki az összeszerelési területet az alapon",
    gr: "Επίλεξε την περιοχή συναρμολόγησης στη βάση",
    dk: "Vælg samlingsområdet på basen",
    pt: "Escolhe a área de montagem da base",
  },
  errorInvalidPdfGeneration: {
    ru: "PDF generation and sending email error. Please try again later or upload other image.",
    en: "We couldn't find the code you entered. Please double-check and ensure that you haven't mistakenly used the letter 'i' instead of the number '1'. Please note that the code should only consist of Latin letters and numbers.",
    pl: "Nie mogliśmy znaleźć wprowadzonego kodu. Upewnij się, że przez pomyłkę nie użyłeś litery 'i' zamiast cyfry '1'. Należy pamiętać, że kod powinien składać się wyłącznie z liter alfabetu łacińskiego i cyfr.",
    es: "No hemos encontrado el código que has introducido. Por favor, compruebe que no ha utilizado por error la letra 'i' en lugar del número '1'. Tenga en cuenta que el código sólo debe constar de letras y números latinos.",
    it: "Non siamo riusciti a trovare il codice inserito. Si prega di ricontrollare e di assicurarsi di non aver erroneamente utilizzato la lettera 'i' al posto del numero '1'. Il codice deve essere composto solo da lettere e numeri latini.",
    de: "Wir konnten den eingegebenen Code nicht finden. Bitte überprüfe ihn sorgfältig – möglicherweise wurde der Buchstabe „i“ statt der Zahl „1“ verwendet. Der Code darf nur lateinische Buchstaben und Zahlen enthalten.",
    fr: "Nous n’avons pas trouvé le code que vous avez saisi. Veuillez vérifier qu’il ne contient pas par erreur la lettre « i » à la place du chiffre « 1 ». Le code ne doit contenir que des lettres latines et des chiffres.",
    cz: "Zadaný kód se nám nepodařilo najít. Zkontrolujte prosím, zda jste omylem nepoužili písmeno „i“ místo čísla „1“. Kód smí obsahovat pouze latinská písmena a číslice.",
    hu: "Nem találjuk a megadott kódot. Kérjük, ellenőrizd, hogy nem keverted-e össze a betű „i” és a szám „1”. A kód csak latin betűket és számokat tartalmazhat.",
    gr: "Δεν μπορέσαμε να βρούμε τον κωδικό που καταχωρίσατε. Ελέγξτε προσεκτικά μήπως χρησιμοποιήσατε κατά λάθος το γράμμα «i» αντί για τον αριθμό «1». Ο κωδικός πρέπει να περιέχει μόνο λατινικά γράμματα και αριθμούς.",
    dk: "Vi kunne ikke finde den kode, du indtastede. Tjek venligst, om du ved en fejl har brugt bogstavet 'i' i stedet for tallet '1'. Koden må kun bestå af latinske bogstaver og tal.",
    pt: "Não conseguimos encontrar o código que você inseriu. Verifique se não usou a letra 'i' por engano em vez do número '1'. O código deve conter apenas letras latinas e números.",
  },
  errorCouponLimit: {
    ru: "Максимальное количество адресов электронной почты (3) уже связано с этим кодом. Пожалуйста, используйте другой код.",
    en: "The maximum number of email addresses (3) has already been linked to this code. Please use a different code.",
    pl: "Do tego kodu zostało już przypisane maksymalnie 3 adresy e-mail. Proszę użyć innego kodu.",
    es: "Este código ya tiene el número máximo de direcciones de correo electrónico (3) vinculadas. Por favor, utiliza otro código.",
    it: "A questo codice sono già stati associati il numero massimo di indirizzi email (3). Per favore, usa un altro codice.",
    de: "Mit diesem Code sind bereits die maximal zulässigen E-Mail-Adressen (3) verknüpft. Bitte verwende einen anderen Code.",
    fr: "Le nombre maximal d’adresses e-mail (3) est déjà associé à ce code. Veuillez utiliser un autre code.",
    cz: "K tomuto kódu je již přiřazen maximální počet e-mailových adres (3). Použijte prosím jiný kód.",
    hu: "Ehhez a kódhoz már a maximális számú e-mail cím (3) lett hozzárendelve. Kérjük, használj másik kódot.",
    gr: "Έχουν ήδη συσχετιστεί ο μέγιστος αριθμός διευθύνσεων email (3) με αυτόν τον κωδικό. Παρακαλώ χρησιμοποιήστε άλλον κωδικό.",
    dk: "Det maksimale antal e-mailadresser (3) er allerede tilknyttet denne kode. Brug venligst en anden kode.",
    pt: "O número máximo de endereços de e-mail (3) já foi associado a este código. Por favor, utilize um código diferente."
  },
  readyToMosaic: {
    ru: "Готов превратить это фото в настоящую мозаику?",
    en: "Ready to turn this photo into a real mosaic?",
    pl: "Gotowy, aby zamienić to zdjęcie w prawdziwą mozaikę?",
    es: "¿Listo para convertir esta foto en un auténtico mosaico?",
    it: "Pronto a trasformare questa foto in un vero mosaico?",
    de: "Bereit, dieses Foto in ein echtes Mosaik zu verwandeln?",
    fr: "Prêt à transformer cette photo en une véritable mosaïque?",
    cz: "Připraven proměnit tuto fotku v opravdovou mozaiku?",
    hu: "Készen állsz arra, hogy ezt a fotót valódi mozaikká alakítsd?",
    gr: "Έτοιμος να μετατρέψεις αυτή τη φωτογραφία σε ένα πραγματικό μωσαϊκό;",
    dk: "Klar til at forvandle dette foto til en ægte mosaik?",
    pt: "Pronto para transformar esta foto num verdadeiro mosaico?",
  },
  errorServerError: {
    ru: "Ошибка на сервере.",
    en: "Server error. Please contact MIXBRICKS support team.",
    pl: "Server error. Please contact MIXBRICKS support team.",
    es: "Server error. Please contact MIXBRICKS support team.",
    it: "Server error. Please contact MIXBRICKS support team.",
    de: "Server error. Please contact MIXBRICKS support team.",
    fr: "Server error. Please contact MIXBRICKS support team.",
    cz: "Server error. Please contact MIXBRICKS support team.",
    hu: "Server error. Please contact MIXBRICKS support team.",
    gr: "Server error. Please contact MIXBRICKS support team.",
    dk: "Server error. Please contact MIXBRICKS support team.",
    pt: "Server error. Please contact MIXBRICKS support team."
  },
  verifyError: {
    ru: "PDF generation and sending email error. Please try again later or upload other image.",
    en: "We couldn't find the code you entered. Please double-check and ensure that you haven't mistakenly used the letter 'i' instead of the number '1'. Please note that the code should only consist of Latin letters and numbers.",
    pl: "Nie mogliśmy znaleźć wprowadzonego kodu. Upewnij się, że przez pomyłkę nie użyłeś litery 'i' zamiast cyfry '1'. Należy pamiętać, że kod powinien składać się wyłącznie z liter alfabetu łacińskiego i cyfr.",
    es: "No hemos encontrado el código que has introducido. Por favor, compruebe que no ha utilizado por error la letra 'i' en lugar del número '1'. Tenga en cuenta que el código sólo debe constar de letras y números latinos.",
    it: "Non siamo riusciti a trovare il codice inserito. Si prega di ricontrollare e di assicurarsi di non aver erroneamente utilizzato la lettera 'i' al posto del numero '1'. Il codice deve essere composto solo da lettere e numeri latini.",
    de: "Wir konnten den eingegebenen Code nicht finden. Bitte überprüfe ihn sorgfältig – möglicherweise wurde der Buchstabe „i“ statt der Zahl „1“ verwendet. Der Code darf nur lateinische Buchstaben und Zahlen enthalten.",
    fr: "Nous n’avons pas trouvé le code que vous avez saisi. Veuillez vérifier qu’il ne contient pas par erreur la lettre « i » à la place du chiffre « 1 ». Le code ne doit contenir que des lettres latines et des chiffres.",
    cz: "Zadaný kód se nám nepodařilo najít. Zkontrolujte prosím, zda jste omylem nepoužili písmeno „i“ místo čísla „1“. Kód smí obsahovat pouze latinská písmena a číslice.",
    hu: "Nem találjuk a megadott kódot. Kérjük, ellenőrizd, hogy nem keverted-e össze a betű „i” és a szám „1”. A kód csak latin betűket és számokat tartalmazhat.",
    gr: "Δεν μπορέσαμε να βρούμε τον κωδικό που καταχωρίσατε. Ελέγξτε προσεκτικά μήπως χρησιμοποιήσατε κατά λάθος το γράμμα «i» αντί για τον αριθμό «1». Ο κωδικός πρέπει να περιέχει μόνο λατινικά γράμματα και αριθμούς.",
    dk: "Vi kunne ikke finde den kode, du indtastede. Tjek venligst, om du ved en fejl har brugt bogstavet 'i' i stedet for tallet '1'. Koden må kun bestå af latinske bogstaver og tal.",
    pt: "Não conseguimos encontrar o código que você inseriu. Verifique se não usou a letra 'i' por engano em vez do número '1'. O código deve conter apenas letras latinas e números.",
  },
  requiredCode: {
    ru: "Введите код",
    en: "Code is required",
    pl: `Kod jest wymagany`,
    es: `Se requiere código`,
    it: `Il codice è obbligatorio`,
    de: "Code ist erforderlich",
    fr: "Le code est requis",
    cz: "Kód je vyžadován",
    hu: "A kód megadása kötelező",
    gr: "Απαιτείται κωδικός",
    dk: "Kode er påkrævet",
    pt: "O código é obrigatório",
  },
  invalidCode: {
    ru: "Код имеет неверный формат",
    en: "Code has invalid format",
    pl: `Kod ma nieprawidłowy format`,
    es: `El código tiene un formato no válido`,
    it: `Il codice ha un formato non valido`,
    de: "Code hat ein ungültiges Format",
    fr: "Le code a un format invalide",
    cz: "Kód má neplatný formát",
    hu: "A kód formátuma érvénytelen",
    gr: "Ο κωδικός έχει μη έγκυρη μορφή",
    dk: "Koden har ugyldigt format",
    pt: "O código tem um formato inválido",
  },
  chooseCountry: {
    ru: "ВЫБЕРИТЕ СТРАНУ",    
    pl: "WYBIERZ SWÓJ KRAJ",
    en: "CHOOSE YOUR COUNTRY",
    es: "ELIGE TU PAÍS",
    it: "SCEGLI IL TUO PAESE",
    de: "WÄHLEN SIE IHR LAND",
    fr: "CHOISISSEZ VOTRE PAYS",
    cz: "VYBERTE SVOU ZEMI",
    hu: "VÁLASSZA KI ORSZÁGÁT",
    gr: "ΕΠΙΛΕΞΤΕ ΤΗ ΧΩΡΑ ΣΑΣ",
    dk: "VÆLG DIT LAND",
    pt: "ESCOLHA O SEU PAÍS",    
  },
  buttonPoland: {
    ru: "Польша", 
    pl: "Polska",
    en: "Poland",
    it: "Polonia",
    es: "Polonia",
    de: "Polen",
    fr: "Pologne",
    cz: "Polsko",
    hu: "Lengyelország",
    gr: "Πολωνία",
    dk: "Polen",
    pt: "Polónia",    
  },
  buttonEU: {
    ru: "Другие страны ЕС",    
    pl: "Inne Państwa UE",
    en: "Other EU countries",
    it: `Altri paesi dell'UE`,
    es: "Otros países de la UE",
    de: "Andere EU-Länder",
    fr: "Autres pays de l’UE",
    cz: "Ostatní země EU",
    hu: "Egyéb uniós országok",
    gr: "Άλλες χώρες της ΕΕ",
    dk: "Andre EU-lande",
    pt: "Outros países da UE",
  },
  // Admin 
  logoText: {
    en: "Creative MindFulness",
    it: "Mente creativa",
    es: "Mindfulness Creativo",
    pl: "Inteligencja twórcza ",
  },
  contactUs: {
    en: `Contact us: `,
    it: `Contattaci: `,
    es: `Ponte en contacto con nosotros: `,
    pl: `Skontaktuj się z nami: `,
  },
  contactEmail: {
    en: "support@mixbricks.store",
    it: "support@mixbricks.store",
    es: "support@mixbricks.store",
    pl: "support@mixbricks.store",
  },
  goToStore: {
    en: "Go to store",
    it: "Vai al negozio",
    es: "Ir a la tienda",
    pl: "Przejdź do sklepu",
  },  
  // uploadPhotoButtonHomePage: {
  //   en: "Upload a photo",
  //   it: "Carica una foto",
  //   es: "Subir foto",
  //   pl: "Prześlij zdjęcie",
  // },
  // chooseDesignsButtonHomePage: {
  //   en: "Choose designs",
  //   it: "Scegli i disegni",
  //   es: "Elige diseños",
  //   pl: "Wybierz projekty",
  // },

  // verifyCouponPageTitle: {
  //   en: "Enter the ‘Let's String’ code provided in your kit",
  //   it: `Inserisci codice "Let's String" fornito nel kit`,
  //   es: `Introduce el código "Let's String" que se incluye en tu kit`,
  //   pl: `Wprowadź kod "Let's String" dostarczony w zestawie.`,
  // },
  // buttonBack: {
  //   en: "Back",
  //   it: `Indietro`,
  //   es: `Volver`,
  //   pl: `Powrót`,
  // },
  // buttonFurther: {
  //   en: "Next",
  //   it: `Avanti `,
  //   es: `Más`,
  //   pl: `Dalej`,
  // },
  // showReadyArtTitle: {
  //   en: 'Click "further" to continue',
  //   it: `Fare clic su «Più avanti» per continuare`,
  //   es: `Haga clic en «Más información» para continuar`,
  //   pl: `Naciśnij «Dalej», aby kontynuować`,
  // },
  // uploadPageTitle: {
  //   en: "The file size should not exceed 15 MB",
  //   it: `La dimensione del file non deve superare i 15 MB`,
  //   es: `El tamaño del archivo no debe superar los 15 MB`,
  //   pl: `Rozmiar pliku nie może przekraczać 15 MB`,
  // },
  // uploadButton: {
  //   en: "Upload a photo",
  //   it: `Carica una foto`,
  //   es: `Suba una foto`,
  //   pl: `Prześlij zdjęcie`,
  // },
  // cropPageTitle: {
  //   en: "Please adjust the image",
  //   it: `Si prega di regolare l'immagine`,
  //   es: `Ajusta la imagen`,
  //   pl: `Prosimy o przygotowanie zdjęcia`,
  // },
  // generateArtPageTitle: {
  //   en: "Please stay on this page without closing your browser. The loading will take up to 5-10 minutes",
  //   it: `Rimani su questa pagina senza chiudere il browser. Il caricamento richiederà fino a 5-10 minuti`,
  //   es: `Permanezca en esta página sin cerrar su navegador. La carga tardará entre 5 y 10 minutos`,
  //   pl: `Proszę pozostać na tej stronie, nie zamykając przeglądarki. Ładowanie może potrwać od 5 do 10 minut`,
  // },
  // enterEmailPageTitle: {
  //   en: "Congratulations! Your instructions are ready! Please, enter your email address and we will immediately send instructions for assembly",
  //   it: `Congratulazioni! Le istruzioni sono pronte! Inserite il vostro indirizzo e-mail e vi invieremo immediatamente le istruzioni per il montaggio.`,
  //   es: `¡Enhorabuena! ¡Sus instrucciones están listas! Por favor, introduzca su dirección de correo electrónico y le enviaremos inmediatamente las instrucciones de montaje`,
  //   pl: `Gratulacje! Twoja instrukcja jest gotowa! Wprowadź swoj adres e-mail a my natychmiast wyślemy instrukcje montażu`,
  // },
  // attentionText: {
  //   en: "Pay attention! Assembly instructions can be sent to the mail no more than 3 times. Then the code will be inactive",
  //   it: `Attenzione! Le istruzioni di montaggio possono essere inviate per posta non più di 3 volte. In tal caso il codice non sarà più attivo`,
  //   es: `¡Atención! Las instrucciones de ensamblaje pueden enviarse al correo no más de 3 veces. Luego, el código estará inactivo`,
  //   pl: `Uwaga! Instrukcja montażu może zostać wysłana na adres e-mail nie więcej niż 3 razy. Następnie kod będzie nieaktywny`,
  // },
  // additionalText: {
  //   en: 'By clicking on the "Send" button, I give my permission to process my personal data for the purpose of informing me about special offers and prices. I can revoke this consent at any time by writing to support@mixbricks.store.',
  //   it: `Facendo clic sul pulsante "Invia", do il mio consenso al trattamento dei miei dati personali allo scopo di informarmi su offerte e prezzi speciali. Posso revocare questo consenso in qualsiasi momento scrivendo a support@mixbricks.store`,
  //   es: `Al hacer clic en el botón "Enviar", doy mi permiso para procesar mis datos personales con el fin de informarme sobre ofertas especiales y precios. Puedo revocar este consentimiento en cualquier momento escribiendo a support@mixbricks.store.`,
  //   pl: `Klikając przycisk "Wyślij", wyrażam zgodę na przetwarzanie moich danych osobowych w celu informowania mnie o ofertach specjalnych i cenach. Mogę odwołać tę zgodę w dowolnym momencie, pisząc na adres support@mixbricks.store.`,
  // },
  // sendButton: {
  //   en: "Send",
  //   it: `Invia`,
  //   es: `Enviar`,
  //   pl: `Wysłać`,
  // },
  // enterEmailError: {
  //   en: "Please enter a valid e-mail",
  //   it: "Inserisci una email valida",
  //   es: "Por favor introduzca una dirección de correo electrónico válida",
  //   pl: "Proszę podać poprawny adres e-mail",
  // },
  // requiredEmail: {
  //   en: "Email is required",
  //   it: "L'e-mail è obbligatoria",
  //   es: "correo electronico es requerido",
  //   pl: "Email jest wymagany",
  // },
  // confirmEmailPageTitle: {
  //   en: "Please check your Email",
  //   it: "Controlla l'e-mail",
  //   es: "Compruebe su dirección de correo electrónico",
  //   pl: "Sprawdź swój adres e-mail",
  // },
  // confirmEmailText: {
  //   en: "Is this email correct?",
  //   it: "L'e-mail è corretta?",
  //   es: "¿Es correcto este correo electrónico?",
  //   pl: "Czy ten adres e-mail jest prawidłowy?",
  // },
  // yesButton: {
  //   en: "Yes",
  //   it: "Sì",
  //   es: "Sí",
  //   pl: "Tak",
  // },
  // noButton: {
  //   en: "No",
  //   it: "No",
  //   es: "No",
  //   pl: "Nie",
  // },
  // finalPageTitle: {
  //   en: "Your instructions for printing and for online assembly are in your Email",
  //   it: "Le istruzioni per la stampa e per il montaggio online sono nella vostra e-mail",
  //   es: "Sus instrucciones para la impresión y el montaje en línea se encuentran en su correo electrónico",
  //   pl: "Instrukcje dotyczące drukowania i montażu online znajdują się w wiadomości e-mail",
  // },
  // finalPageText: {
  //   en: "You can now join the journey to Creative Mindfulness 🌱",
  //   it: "Ora potete unirvi al viaggio verso la Mindfulness creativa 🌱",
  //   es: "Ya puedes unirte al viaje hacia Atención Plena Creativa 🌱",
  //   pl: "Teraz możesz dołączyć do podróży w kreatywność opartą na uważności 🌱",
  // },
  // startAssemblyButton: {
  //   en: "Start assembly online",
  //   it: "Iniziare l'assemblaggio online",
  //   es: "Iniciar el montaje en línea",
  //   pl: "Rozpocznij montaż online",
  // },
  // downloadPDFButton: {
  //   en: "Download PDF-instruction",
  //   it: "Scarica le istruzioni in PDF",
  //   es: "Descargar instrucciones en PDF",
  //   pl: "Pobierz instrukcję w formacie PDF",
  // },
  // goToMainPageButton: {
  //   en: "Main page",
  //   it: "Pagina principale",
  //   es: "Página principal",
  //   pl: "Strona główna",
  // },
  // chooseButton: {
  //   en: "Choose",
  //   it: "Scegliere",
  //   es: "Elegir",
  //   pl: "Wybierz",
  // },
  // readyDesignsText: {
  //   en: " If you're not sure which photo to use, you can choose one from the images we've carefully prepared for you",
  //   it: "Se non siete sicuri di quale foto usare, potete sceglierne una tra le immagini che abbiamo preparato con cura per voi.",
  //   es: "Si no estás seguro(a) de qué foto escoger, puedes elegir una de las imágenes que hemos preparado cuidadosamente para ti.",
  //   pl: "Jeśli nie masz pewności, które zdjęcie wybrać, możesz skorzystać z jednego z obrazów, które starannie dla Ciebie przygotowaliśmy.",
  // },
  // lostButton: {
  //   en: "I'm lost",
  //   it: "Mi sono persə",
  //   es: "Estoy perdido",
  //   pl: "Zgubiłem się",
  // },
  // noMusic: {
  //   en: "No music",
  //   it: "Nessuna musica",
  //   es: "Sin música",
  //   pl: "Bez muzyki",
  // },
  // enterStepField: {
  //   en: "Enter the step where you left off",
  //   it: "Inserite il passo in cui vi siete fermati",
  //   es: "Introduzca el paso donde lo dejó",
  //   pl: "Wprowadź krok, na którym skończyłeś",
  // },
  // yourStep: {
  //   en: "Your step:",
  //   it: "Il tuo passo:",
  //   es: "Tu paso:",
  //   pl: "Twój krok:",
  // },
};
